export const UserRolesEnum = {
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN"
}

export const UserRolesList = [
  "ADMIN",
  "SUPERADMIN"
]
